import React, { useState } from 'react';
import { Button } from '@chakra-ui/react';
import classNames from 'classnames';
import { CMXIcon } from '@codametrix/ui-components';
import { appServiceLines } from '@codametrix/ui-common';

interface TimeBasedCodePopoverProps {
  codableTransaction: CMxCommonApp.CodableTransaction;
  handleTimeBasedCodeAdd: (
    ev: React.MouseEvent<HTMLElement>,
    time: string,
    age: string
  ) => void;
  handleTimeBasedCodeUpdate: (
    ev: React.MouseEvent<HTMLElement>,
    time: string,
    age: string
  ) => void;
  processInstance: AmplifyAPI.ProcessInstance;
  popoverState?: boolean;
  updatePopoverState?: (newState: boolean) => void;
}

const TimeBasedCodePopover: React.FC<TimeBasedCodePopoverProps> = ({
  codableTransaction,
  handleTimeBasedCodeAdd,
  handleTimeBasedCodeUpdate,
  processInstance,
  updatePopoverState,
  popoverState
}) => {
  const [time, setTime] = useState<string>(
    codableTransaction?.procedure?.total_time || ''
  );
  const [age, setAge] = useState<string>(
    codableTransaction?.procedure?.age ||
      (processInstance?.age && processInstance?.age?.toString()) ||
      ''
  );

  const isNewValue = codableTransaction?.procedure?.total_time === null;
  const hasAddOnCode = codableTransaction?.procedure?.add_on_code_available;
  const isTimePresent = codableTransaction?.procedure?.total_time !== null;

  const handleActionButtonClick = (ev: React.MouseEvent<HTMLElement>) => {
    ev.stopPropagation();
    if (isNewValue) {
      handleTimeBasedCodeAdd(ev, time, age);
    } else {
      handleTimeBasedCodeUpdate(ev, time, age);
    }
    updatePopoverState(false);
  };

  const handleClose = (ev: React.MouseEvent<HTMLElement>) => {
    // Close the popover and reset the clickTriggered state
    updatePopoverState(false);
    setTime(codableTransaction?.procedure?.total_time || '');
    setAge(
      codableTransaction?.procedure?.age ||
        (processInstance?.age && processInstance?.age?.toString()) ||
        ''
    );
    ev.stopPropagation();
  };

  let buttonText = '';
  if (hasAddOnCode) {
    buttonText = isTimePresent ? 'Regenerate' : 'Generate';
  } else {
    buttonText = 'Save';
  }

  return (
    <div
      className={classNames('time-based-code-popover', {
        magic: hasAddOnCode
      })}>
      <div className="input-section">
        {appServiceLines.isSurgery(processInstance?.serviceLine ?? 'NONE') && (
          <div>
            <label className="time-label">Patient Age</label>
            <input
              name={'age'}
              type="number"
              className={classNames('time-input', {
                magic: hasAddOnCode
              })}
              placeholder="Enter patient age"
              value={age}
              onClick={(ev: React.MouseEvent<HTMLInputElement>) => {
                ev.stopPropagation();
              }}
              onChange={(e) => setAge(e.target.value)}
            />
          </div>
        )}

        <div>
          <label className="time-label">Total Procedure Time</label>
          <input
            name={'total-time'}
            type="number"
            className={classNames('time-input', {
              magic: hasAddOnCode
            })}
            placeholder="Enter minutes"
            value={time}
            onClick={(ev: React.MouseEvent<HTMLInputElement>) => {
              ev.stopPropagation();
            }}
            onChange={(e) => setTime(e.target.value)}
          />
        </div>
      </div>
      <div className="button-section">
        <Button onClick={handleClose} variant="secondary">
          Cancel
        </Button>
        <Button
          onClick={handleActionButtonClick}
          disabled={!time.trim()}
          variant="primary"
          className={classNames(`magic-button`, {
            disabled: !time.trim(),
            magic: hasAddOnCode
          })}
          leftIcon={
            hasAddOnCode && (
              <CMXIcon svgIconName="BiomeAutomation" svgIconSize="20" />
            )
          }>
          {buttonText}
        </Button>
      </div>
    </div>
  );
};

export default TimeBasedCodePopover;
